import React from "react";

export default props => {
  const { colors, textStyle, ...rest } = props;
  const { skyNight, water, stars, mainShape } = colors;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 350 90" {...rest}>
      <circle fill={stars} cx="36.5" cy="16.12" r="2" />
      <path
        fill={mainShape}
        d="M50,3.34A41.66,41.66,0,1,1,8.29,45,41.71,41.71,0,0,1,50,3.34ZM84.39,57.83a36.76,36.76,0,1,0-68.89,0,6.21,6.21,0,0,0,6-6.19h4.9a6.21,6.21,0,0,0,12.42,0h4.9a6.21,6.21,0,0,0,12.41,0h4.9a6.21,6.21,0,0,0,12.42,0h4.9A6.21,6.21,0,0,0,84.39,57.83ZM82.27,62.5a11.13,11.13,0,0,1-6.35-3.92,11.09,11.09,0,0,1-17.32,0,11.08,11.08,0,0,1-17.31,0,11.09,11.09,0,0,1-17.32,0,11.1,11.1,0,0,1-6.34,3.92A37,37,0,0,0,26.11,73a5.63,5.63,0,0,0,5.23-5.61h4.91a5.62,5.62,0,1,0,11.24,0H52.4a5.63,5.63,0,0,0,11.25,0h4.9A5.63,5.63,0,0,0,73.79,73,37.29,37.29,0,0,0,82.27,62.5Zm-13.33,14a10.5,10.5,0,0,1-2.84-2.38,10.69,10.69,0,0,1-4.61,3.2A10.49,10.49,0,0,1,50,74.08a10.51,10.51,0,0,1-11.55,3.2,10.66,10.66,0,0,1-4.6-3.2A10.7,10.7,0,0,1,31,76.46a36.68,36.68,0,0,0,31.34,3.16A35.9,35.9,0,0,0,68.94,76.46Z"
      />
      <path fill={stars} d="M65.91,40a2,2,0,1,1-2,2A2,2,0,0,1,65.91,40Z" />
      <path
        fill={stars}
        d="M77.86,31.68a2,2,0,0,1,0,4H77v.82a2,2,0,1,1-4,0v-.82h-.82a2,2,0,1,1,0-4H73v-.83a2,2,0,0,1,4,0v.83Z"
      />
      <path
        fill={skyNight}
        d="M86.7,45a36.63,36.63,0,0,1-2.31,12.83,6.21,6.21,0,0,1-6-6.19h-4.9a6.21,6.21,0,0,1-12.42,0h-4.9a6.21,6.21,0,0,1-12.41,0h-4.9a6.21,6.21,0,0,1-12.42,0h-4.9a6.21,6.21,0,0,1-6,6.19A36.76,36.76,0,1,1,86.7,45ZM79.85,33.67a2,2,0,0,0-2-2H77v-.83a2,2,0,0,0-4,0v.83h-.82a2,2,0,1,0,0,4H73v.82a2,2,0,1,0,4,0v-.82h.83A2,2,0,0,0,79.85,33.67ZM67.91,42a2,2,0,1,0-2,2A2,2,0,0,0,67.91,42Zm-.7-21.71a2,2,0,1,0-2,2A2,2,0,0,0,67.21,20.32Zm-9.94,6.29a9.72,9.72,0,0,0-9.72-9.72,9.45,9.45,0,0,0-2.51.34A11.83,11.83,0,0,1,45,36a9.87,9.87,0,0,0,2.51.34A9.72,9.72,0,0,0,57.27,26.61ZM47.6,44.83a2,2,0,1,0-2,2A2,2,0,0,0,47.6,44.83ZM38.5,16.12a2,2,0,1,0-2,2A2,2,0,0,0,38.5,16.12ZM36.4,31a2,2,0,1,0-2,2A2,2,0,0,0,36.4,31Zm-8,9a2,2,0,0,0-2-2h-.82v-.82a2,2,0,1,0-4,0v.82h-.82a2,2,0,1,0,0,4h.82v.82a2,2,0,1,0,4,0v-.82h.82A2,2,0,0,0,28.39,39.93Z"
      />
      <path
        fill={water}
        d="M75.92,58.58a11.13,11.13,0,0,0,6.35,3.92A37.29,37.29,0,0,1,73.79,73a5.63,5.63,0,0,1-5.24-5.61h-4.9a5.63,5.63,0,0,1-11.25,0H47.49a5.62,5.62,0,1,1-11.24,0H31.34A5.63,5.63,0,0,1,26.11,73,37,37,0,0,1,17.63,62.5,11.1,11.1,0,0,0,24,58.58a11.09,11.09,0,0,0,17.32,0,11.08,11.08,0,0,0,17.31,0,11.09,11.09,0,0,0,17.32,0Z"
      />
      <path
        fill={stars}
        d="M26.39,37.93a2,2,0,1,1,0,4h-.82v.82a2,2,0,1,1-4,0v-.82h-.82a2,2,0,1,1,0-4h.82v-.82a2,2,0,1,1,4,0v.82Z"
      />
      <circle fill={stars} cx="45.6" cy="44.83" r="2" />
      <path
        fill={water}
        d="M66.1,74.08a10.5,10.5,0,0,0,2.84,2.38,35.9,35.9,0,0,1-6.65,3.16l-.8-2.34A10.69,10.69,0,0,0,66.1,74.08Z"
      />
      <path fill={stars} d="M65.2,18.32a2,2,0,1,1-2,2A2,2,0,0,1,65.2,18.32Z" />
      <circle fill={stars} cx="34.4" cy="30.96" r="2" />
      <path
        fill={stars}
        d="M47.55,16.89a9.72,9.72,0,1,1,0,19.44A9.87,9.87,0,0,1,45,36a11.83,11.83,0,0,0,0-18.76A9.45,9.45,0,0,1,47.55,16.89Z"
      />
      <path
        fill={water}
        d="M41.87,77.87A10.54,10.54,0,0,0,50,74.08a10.49,10.49,0,0,0,11.54,3.2l.8,2.34a36.68,36.68,0,0,1-24.69,0l.8-2.34A10.49,10.49,0,0,0,41.87,77.87Z"
      />
      <path
        fill={water}
        d="M38.4,77.28l-.8,2.34A36.2,36.2,0,0,1,31,76.46a10.7,10.7,0,0,0,2.85-2.38A10.66,10.66,0,0,0,38.4,77.28Z"
      />
      <path
        style={textStyle}
        d="M135.66,48.78a.69.69,0,0,1,.21,1,15.61,15.61,0,1,1-12.52-25A15.38,15.38,0,0,1,135.78,31a.7.7,0,0,1-.16,1.06l-3.85,2.66a.81.81,0,0,1-1-.16,9.25,9.25,0,0,0-7.4-3.6,9.47,9.47,0,0,0,0,18.94,9.32,9.32,0,0,0,7.44-3.6.77.77,0,0,1,1-.16Z"
      />
      <path
        style={textStyle}
        d="M136.81,45a11.09,11.09,0,1,1,11.08,11.09A11.12,11.12,0,0,1,136.81,45Zm6.13,0A4.95,4.95,0,1,0,147.89,40,4.94,4.94,0,0,0,142.94,45Z"
      />
      <path
        style={textStyle}
        d="M160.74,45a11.09,11.09,0,1,1,11.08,11.09A11.12,11.12,0,0,1,160.74,45Zm6.13,0A4.95,4.95,0,1,0,171.82,40,4.94,4.94,0,0,0,166.87,45Z"
      />
      <path
        style={textStyle}
        d="M185.4,22.93h4.67a.69.69,0,0,1,.73.74V55.08a.69.69,0,0,1-.73.74H185.4a.69.69,0,0,1-.73-.74V23.67A.69.69,0,0,1,185.4,22.93Z"
      />
      <path
        style={textStyle}
        d="M220.75,48.78a.68.68,0,0,1,.2,1,15.61,15.61,0,1,1-12.51-25A15.39,15.39,0,0,1,220.87,31a.7.7,0,0,1-.16,1.06l-3.85,2.66a.8.8,0,0,1-1-.16,9.25,9.25,0,0,0-7.4-3.6,9.47,9.47,0,0,0,0,18.94,9.32,9.32,0,0,0,7.44-3.6.76.76,0,0,1,1-.16Z"
      />
      <path
        style={textStyle}
        d="M243.33,33.89a.72.72,0,0,1,.74.78V55a.72.72,0,0,1-.74.78h-4.62a.76.76,0,0,1-.78-.78v-.86a.36.36,0,0,0-.61-.28,7.71,7.71,0,0,1-5.57,2.17c-6.09,0-9.86-5-9.86-11.09s3.77-11.09,9.86-11.09A7.49,7.49,0,0,1,237.32,36c.2.29.61.08.61-.25V34.67a.76.76,0,0,1,.78-.78ZM237.93,45a4.95,4.95,0,1,0-5,5A4.94,4.94,0,0,0,237.93,45Z"
      />
      <path
        style={textStyle}
        d="M279.78,45v10.1a.69.69,0,0,1-.74.74h-4.66a.69.69,0,0,1-.74-.74V45c0-3.44-1.64-4.95-4.42-4.95a3.64,3.64,0,0,0-2.78,1.1V55.08a.69.69,0,0,1-.73.74H261a.69.69,0,0,1-.73-.74V45c0-3.44-1.15-4.95-4-4.95-3,0-4,2.21-4,4.95v10.1a.69.69,0,0,1-.74.74H247a.69.69,0,0,1-.74-.74V34.88a.69.69,0,0,1,.74-.74h4.66a.69.69,0,0,1,.74.74v1.47a.37.37,0,0,0,.69.2,6,6,0,0,1,5.36-2.66,7.05,7.05,0,0,1,5.77,2.42.33.33,0,0,0,.53,0,8,8,0,0,1,6.3-2.46C277.73,33.89,279.78,38.88,279.78,45Z"
      />
      <path
        style={textStyle}
        d="M294.14,56.07A7.57,7.57,0,0,1,288.57,54c-.2-.29-.61-.08-.61.24V66.33a.69.69,0,0,1-.74.74h-4.66a.69.69,0,0,1-.74-.74V34.88a.69.69,0,0,1,.74-.74h4.66a.69.69,0,0,1,.74.74v.9a.37.37,0,0,0,.61.28,7.71,7.71,0,0,1,5.57-2.17c6.13,0,9.85,5,9.85,11.09S300.27,56.07,294.14,56.07Zm-1.23-16A5,5,0,1,0,297.86,45,4.94,4.94,0,0,0,292.91,40Z"
      />
      <path
        style={textStyle}
        d="M326,48a.74.74,0,0,1,.7,1,11.06,11.06,0,1,1,.78-4.05v.65a.72.72,0,0,1-.78.7H312.05c-.24,0-.36.12-.36.41.16,2,1.59,3.72,4.74,3.72,1.92,0,3.48-.86,3.85-2A.78.78,0,0,1,321,48Zm-14.11-5.44c0,.28.08.45.37.45h8.3c.29,0,.37-.17.33-.45a4.54,4.54,0,0,0-4.5-3.44A4.47,4.47,0,0,0,311.93,42.57Z"
      />
      <path
        style={textStyle}
        d="M341.71,34.67v4.62a.72.72,0,0,1-.78.74h-.16A4.94,4.94,0,0,0,335.82,45v10.1a.69.69,0,0,1-.74.74h-4.66a.69.69,0,0,1-.74-.74V34.88a.69.69,0,0,1,.74-.74h4.66a.69.69,0,0,1,.74.74v.85c0,.33.41.54.61.25a7.26,7.26,0,0,1,4.42-2A.69.69,0,0,1,341.71,34.67Z"
      />
    </svg>
  );
};
